import { render, staticRenderFns } from "./perform-billing-confirm-itens-modal.component.vue?vue&type=template&id=34310c3c&scoped=true&"
import script from "./perform-billing-confirm-itens-modal.component.vue?vue&type=script&lang=ts&"
export * from "./perform-billing-confirm-itens-modal.component.vue?vue&type=script&lang=ts&"
import style0 from "./perform-billing-confirm-itens-modal.component.vue?vue&type=style&index=0&id=34310c3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34310c3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VDialog,VDivider})
